/**
 * 「+N」スコア加算ポップ(docs/02_game_design.md §3。Unity版 DOTween 演出の再現)。
 *
 * store を経由せず controller の effects を直接購読する
 * (打鍵ごとに全体を再レンダリングしないため)。
 */

import { useEffect, useState } from 'react';
import type { Emitter } from '../../bridge/emitter';
import type { PlayEffect } from '../../bridge/playController';

interface Pop {
  readonly id: number;
  readonly gain: number;
  readonly offset: number;
}

const MAX_POPS = 8;
const POP_MS = 700;

export function ScorePops({ effects }: { readonly effects: Emitter<PlayEffect> }) {
  const [pops, setPops] = useState<readonly Pop[]>([]);

  useEffect(() => {
    let seq = 0;
    const timers = new Set<ReturnType<typeof setTimeout>>();
    const off = effects.on((effect) => {
      if (effect.type !== 'correct' || effect.gain <= 0) return;
      const id = ++seq;
      const pop: Pop = { id, gain: effect.gain, offset: (id % 5) * 14 - 28 };
      setPops((prev) => [...prev.slice(-(MAX_POPS - 1)), pop]);
      const timer = setTimeout(() => {
        setPops((prev) => prev.filter((item) => item.id !== id));
        timers.delete(timer);
      }, POP_MS);
      timers.add(timer);
    });
    return () => {
      off();
      for (const timer of timers) clearTimeout(timer);
    };
  }, [effects]);

  return (
    <div className="score-pops" aria-hidden="true">
      {pops.map((pop) => (
        <span key={pop.id} className="score-pop" style={{ left: `calc(50% + ${pop.offset}px)` }}>
          +{pop.gain}
        </span>
      ))}
    </div>
  );
}
